// AI Generated Component
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoadingService } from '@monsido/angular-shared-components';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { PageService } from '@client/app/services/entities/page/page.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { MonModalService } from '@client/app/modules/modals/services/mon-modal/mon-modal.service';

@Component({
    selector: 'page-link-dropdown',
    standalone: false,
    template: `
        <mon-action-menu [hidden]="showUnignore" [monActionMenuItems]="dropdownOptions">
            <span>{{ 'Action' | translate }}</span>
        </mon-action-menu>

        <a *ngIf="showUnignore"
           class="cursor-pointer"
           (click)="handleUnignoreClick()"
           role="button">
            <span class="fas fa-eye"></span>
            <span>{{ 'Unignore' | translate }}</span>
        </a>
    `,
})
export class PageLinkDropdownComponent implements OnInit {
    @Input() link: any;
    @Input() pageId: any;
    @Input() showUnignore: boolean = false;
    @Input() ignoredValue: string = 'ignored';

    @Output() getPage = new EventEmitter();

    dropdownOptions: any[] = [];
    deleteDialog: any;

    constructor (
        private loadingService: LoadingService,
        private linksRepoService: LinksRepoService,
        private translateService: TranslateService,
        private pageService: PageService,
        private monEventService: MonEventService,
        private monModalService: MonModalService,
    ) {}

    ngOnInit () {
        this.showUnignore = this.showUnignore || false;
        this.pageId = this.pageId || false;
        this.ignoredValue = this.ignoredValue || 'ignored';

        const dropdown = [
            {
                label: this.translateService.getString('Set to fixed'),
                icon: 'faCheck',
                action: () => this.update('fixed'),
                eventParams: { action: 'broken-links-set-to-fixed' },
                shouldShow: this.link.status !== 'fixed' && this.link.status !== 'ignored' && this.pageId,
            },
            {
                label: this.translateService.getString('Mark as ignored'),
                icon: 'faEyeSlash',
                action: () => this.confirmUpdate(this.ignoredValue, this.translateService.getString('Are you sure you want to mark this link as ignored?')),
                eventParams: { action: 'broken-links-mark-as-ignored' },
                shouldShow: this.link.status !== 'ignored' && this.pageId,
            },
            {
                label: this.translateService.getString('Unignore'),
                icon: 'faEye',
                action: () => this.confirmUpdate('dead', this.translateService.getString('Are you sure you want to Mark this link as unignored?')),
                eventParams: { action: 'broken-links-unignore' },
                shouldShow: this.link.status === 'ignored' && this.pageId,
            },
            {
                label: this.translateService.getString('Mark as not fixed'),
                icon: 'faTimes',
                action: () => this.confirmUpdate('dead', this.translateService.getString('Are you sure you want to mark this link as not fixed?')),
                eventParams: { action: 'broken-links-mark-as-not-fixed' },
                shouldShow: this.link.status === 'fixed' && this.pageId,
            },
            {
                label: this.translateService.getString('Mark as fixed'),
                icon: 'faCheck',
                action: () => this.confirmUpdate('fixed', this.translateService.getString('Are you sure you want to mark this link as fixed?')),
                eventParams: { action: 'broken-links-mark-as-fixed' },
                shouldShow: this.link.status !== 'fixed' && this.link.status !== 'ignored' && !this.pageId,
            },
            {
                label: this.translateService.getString('Mark as ignored'),
                icon: 'faEyeSlash',
                action: () => this.confirmUpdate(this.ignoredValue, this.translateService.getString('Are you sure you want to mark this link as ignored?')),
                eventParams: { action: 'broken-links-mark-as-ignored' },
                shouldShow: this.link.status !== 'ignored' && !this.pageId,
            },
            {
                label: this.translateService.getString('Unignore'),
                icon: 'faEye',
                action: () => this.confirmUpdate('dead', this.translateService.getString('Are you sure you want to unignore this link?')),
                eventParams: { action: 'broken-links-unignore' },
                shouldShow: this.link.status === 'ignored' && !this.pageId,
            },
            {
                label: this.translateService.getString('Mark as not fixed'),
                icon: 'faTimes',
                action: () => this.confirmUpdate('dead', this.translateService.getString('Are you sure you want to mark this link as not fixed?')),
                eventParams: { action: 'broken-links-mark-as-not-fixed' },
                shouldShow: this.link.status === 'fixed' && !this.pageId,
            },
        ];

        this.dropdownOptions = dropdown.filter((option) => option.shouldShow !== false).map(item => {
            return {
                label: item.label,
                leftIcon: item.icon,
                action: () => {
                    this.monEventService.run('actionTrigger', item.eventParams);
                    item.action();
                },
            };
        });
    }

    handleUnignoreClick () {
        this.monEventService.run('actionTrigger', { action: 'broken-links-unignore' });
        this.confirmUpdate('dead', this.translateService.getString('Are you sure you want unignore this link?'));
    }

    confirmUpdate (loadingTextKey: string, confirmMessage: string) {
        this.monModalService.confirm(confirmMessage).then(() => {
            this.update(loadingTextKey);
        });
    }

    update (loadingTextKey: string) {
        const loadingTexts = {
            fixed: this.translateService.getString('Marking broken link as fixed'),
            ignored: this.translateService.getString('Ignoring broken link'),
            dead: this.translateService.getString('Reverting state'),
        };

        let promise: any;
        this.deleteDialog = this.loadingService.service(this.translateService.getString('Please wait') + ' - ' + loadingTexts[loadingTextKey]);

        if (typeof this.pageId === 'number') {
            promise = this.updateForPage(loadingTextKey);
        } else {
            promise = this.updateForDomain(loadingTextKey);
        }

        promise
            .then(() => {
                this.getPage.emit();
            }, () => {})
            .finally(() => {
                this.deleteDialog.close();
            });
    }

    updateForPage (param: string) {
        const params: any = {};
        params.status = param;

        return this.pageService.updateLink(this.pageId, this.link.id, params);
    }

    updateForDomain (param: string) {
        const params: any = {};
        params.status = param;
        params.id = this.link.id;

        return this.linksRepoService.update(params);
    }
}
